var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.0793592,31.1237725 L36.7086301,53.9122231 C38.1481251,55.3625923 40.4820194,55.3625923 41.9208155,53.9122231 C43.3597282,52.4631441 43.3597282,50.1128773 41.9208155,48.6639156 L21.8974044,28.4996188 L41.9202332,8.3360258 C43.3591458,6.88636032 43.3591458,4.53632812 41.9202332,3.08724911 C40.4813206,1.63758363 38.1475427,1.63758363 36.7080477,3.08724911 L14.0787768,25.8760515 C13.3593205,26.6009429 13,27.5499876 13,28.4995015 C13,29.4494846 13.3600193,30.399233 14.0793592,31.1237725 Z"}));
}

ArrowLeft.defaultProps = {"width":"56px","height":"56px","viewBox":"0 0 56 56","version":"1.1"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
